import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { ResourceListResponse } from "@/hooks/queries/resource-types";

// Resources list hook (Story 17.2). Wraps `apiFetch` + `useQuery` — no manual
// fetch/useEffect, no bespoke fetch wrapper (mirrors useListClients). The CITS
// reference set is small and fixed (3 docs), so there is no pagination or params.
// `skipAuthRefresh` is deliberately OMITTED: this is a post-session data call and
// MUST ride the silent-refresh path (opposite of the pre-session auth screens).

/** Root key for the resources query — `invalidateQueries(["resources"])` matches it. */
export const RESOURCES_QUERY_KEY = "resources";

export function useResources() {
  return useQuery({
    queryKey: [RESOURCES_QUERY_KEY],
    queryFn: () => apiFetch<ResourceListResponse>("/resources"),
  });
}
